// src/helpers/notifications/channels.ts

export interface Channel {
    key: string;
    label: string;
    defaultEnabled: boolean;
}

export const CHANNELS: Channel[] = [
    { key: 'inApp', label: 'In-App', defaultEnabled: true },
    { key: 'email', label: 'Email', defaultEnabled: true },
    // add SMS, push, etc. here if needed
];
